<template>
  <v-card
    loader-height="8"
    :disabled="admin.componentsLoading"
    :loading="admin.componentsLoading"
    :min-height="minCardHeight"
    :class="transparent"
    rounded
    min-width="400"
  >
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      Components
      <v-spacer></v-spacer>

      <v-icon>{{ app.componentIcon }}</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        @dblclick:row="showDialog"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="componentListHeaders"
        :items="admin.componentList"
        :items-per-page="15"
        sort-by="sequence"
      >
        <template v-slot:item.published="{ item }">
          <v-icon color="success" v-show="item.published">mdi-check</v-icon>
        </template>
        <template v-slot:item.productTypeId="{ item }">
          {{ getProductTypeName(item.productTypeId) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        v-show="admin.selectedSubsystem != null"
        dark
        color="blue darken-2"
        @click="addNewComponent"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        componentListHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'NAME', value: 'name' },
          { text: 'DESC', value: 'description' },
          { text: 'SEQ', value: 'sequence' },
          { text: 'PRODUCT TYPE', value: 'productTypeId' },
          { text: 'PUBLISHED', value: 'published' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      transparent: {
        get() {
          return this.admin.selectedSubsystem ? '' : 'skeleton';
        }
      },
      selectionModel: {
        get() {
          return this.admin.selectedComponentSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedComponentSelectionModel',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Updates the dialog flag in state
       */
      showDialog: function () {
        this.$store.commit('admin/setShowEditComponentDialog', true);
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(true);
      },
      /**
       * Creates a new Component
       */
      addNewComponent() {
        this.$store.commit('admin/setSelectedComponent', {
          id: 'new',
          subsystemDefinitionId: this.admin.selectedSubsystem.id,
          name: '',
          description: '',
          productTypeId: '',
          published: false,
          sequence: null
        });
        // auto tab switch
        this.$store.commit(
          'admin/setCurrentSystemTab',
          this.admin.SYSTEM_TABS.COMPONENT
        );
        this.$store.commit('admin/setShowEditComponentDialog', true);
        // clear selection models
        this.clearChildSelectionModels();
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedComponent', data.item);
          this.$store.dispatch(
            'admin/getComponentRequirementList',
            data.item.id
          );
          this.$store.dispatch('admin/getComponentSettingList', data.item.id);
          // auto tab switch
          this.$store.commit(
            'admin/setCurrentSystemTab',
            this.admin.SYSTEM_TABS.COMPONENT
          );
        } else {
          this.$store.commit('admin/setSelectedComponent', null);
          // auto tab switch
          //this.$store.commit("admin/setCurrentSystemTab", this.admin.SYSTEM_TABS.SUBSYSTEM)
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears child selection models
       */
      clearChildSelectionModels() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedComponentRequirementSelectionModel',
          value: null
        });
        this.$store.commit('admin/setSelectedComponentRequirement', null);
        this.$store.commit('admin/setComponentRequirementList', []);

        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedComponentSettingSelectionModel',
          value: null
        });
        this.$store.commit('admin/setSelectedComponentSetting', null);
        this.$store.commit('admin/setComponentSettingList', []);
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedComponentSelectionModel',
          value: null
        });
      }
    }
  };
</script>
